import { useEffect, useRef } from 'react';

export const useMountEffect = (cb, deps) => {
    const { current: { isMounted, setMounted } } = useRef((() => {
        let mounted = false;

        return {
            isMounted: () => mounted,
            setMounted: val => mounted = val
        };
    })());

    useEffect(() => {
        setMounted(true);
        const unmount = cb(isMounted);

        return () => {
            setMounted(false);
            typeof unmount === 'function' && unmount();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
